/**
 * @description:
 * This file is used for legacy styling please use the SC theme (./theme.ts), this file should not be added to.
 *
 * @notes
 * The derpy as fuck `mainTheme?.colors.blah || "#00ADEE" is for the unit-tests.
 * There is a horrid circular reference going on which is caused by not fully deprecating this file.
 * Normal running of the website should be totally un-affected.
 */

import mainTheme from "./theme"

type BrandThemeType = typeof mainTheme.colors.brand

const callToAction = {
  default: mainTheme?.colors.callToAction.default || "#00ADEE",
  hover: mainTheme?.colors.callToAction.hover || "#00ADEE",
  pressed: mainTheme?.colors.callToAction.pressed || "#00ADEE"
}

const success = mainTheme?.colors.tertiary.g_400 || "#00ADEE"
const error = mainTheme?.colors.tertiary.r_400 || "#00ADEE"
const fontColor = mainTheme?.colors.fontColor || "#00ADEE"
const tooltip = mainTheme?.colors.tooltip || "#00ADEE"

const warning = {
  default: callToAction.default
}

const greys = {
  white: mainTheme?.colors.greys.white || "#00ADEE",
  lightest: mainTheme?.colors.greys.lightest || "#00ADEE",
  graphGrey: mainTheme?.colors.greys.graphGrey || "#00ADEE",
  light: mainTheme?.colors.greys.light || "#00ADEE",
  mediumLight: mainTheme?.colors.greys.mediumLight || "#00ADEE",
  medium: mainTheme?.colors.greys.medium || "#00ADEE",
  mediumDark: mainTheme?.colors.greys.mediumDark || "#00ADEE",
  dark: mainTheme?.colors.greys.dark || "#00ADEE",
  black: mainTheme?.colors.greys.black || "#00ADEE",
  disabledText: mainTheme?.colors.greys.disabledText || "#00ADEE",
  disabled: mainTheme?.colors.greys.disabled || "#00ADEE"
}

const borderGreyPrimary = mainTheme?.colors.border.greyPrimary || "#00ADEE"
const borderGreySecondary = mainTheme?.colors.border.greySecondary || "#00ADEE"
const dropShadowGrey = mainTheme?.colors.greys.dropShadowGrey || "#00ADEE"

const perkbox = {
  blue: mainTheme?.colors.perkbox.blue || "#00ADEE",
  darkBlue: mainTheme?.colors.perkbox.darkBlue || "#00ADEE",
  greenBlue: mainTheme?.colors.perkbox.greenBlue || "#00ADEE"
}

const brand: BrandThemeType = {
  default: mainTheme?.colors.brand.default || "#00ADEE",
  shade: mainTheme?.colors.brand.shade || "#00ADEE",
  dark: mainTheme?.colors.brand.dark || "#00ADEE",
  hover: mainTheme?.colors.brand.hover || "#00ADEE"
}

// legacy function to update the brand object in this file, should be removed once we use the theme everywhere
export function updateLegacyBrand(themeBrand: BrandThemeType) {
  Object.keys(themeBrand).forEach((key) => {
    brand[key] = themeBrand[key]
  })
}

const productColors = {
  medical: mainTheme?.colors.products.medical || "#00ADEE",
  perks: perkbox.blue,
  recognition: mainTheme?.colors.products.recognition || "#00ADEE",
  wellness: mainTheme?.colors.products.wellness || "#00ADEE",
  rewards: mainTheme?.colors.products.rewards
}

export {
  perkbox,
  fontColor,
  success,
  warning,
  callToAction,
  greys,
  error,
  brand,
  borderGreyPrimary,
  borderGreySecondary,
  dropShadowGrey,
  tooltip,
  productColors
}
